import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const AltNav = () => {
    const navigate = useNavigate();

    const logoClick = () => {
        navigate('/')
    }
    return (
        <div className='navigation-alt'>
            <img onClick={logoClick} src='images/header-logo.png' width='50px' alt='Dawson Bolen Logo' />

            <Link className='glow-box-btn nav-link' to='/'>
                Home
            </Link>
        </div>
    )
}

export default AltNav
